import { alpha, styled, TypographyProps } from "@mui/material";
import Mui5 from "components/mui5";
import { DivProps } from "components/primitives/Div";
import Typography from "components/Typography";

export const TableHeader = styled("div")((props) => ({
  backgroundColor: props.theme.palette.primary.main,
  color: props.theme.palette.common.white,
}));

export const PaperCard = styled(Mui5.Paper)(() => ({
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export const TableContainer = styled("div")({
  backgroundColor: "white",
  borderRadius: "20px",
  height: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

export const Container = styled("div")(({ theme }) => ({
  flex: 1,
  height: "100%",
  overflowY: "auto",
  borderRadius: "20px",
  boxShadow: theme.shadows[1],
}));

export const RowsBox = styled("div")(() => ({
  flex: 1,
  overflowY: "hidden",
  paddingBottom: "8px",
  "& .data-table-row:last-of-type .exercise-library-table-row-border": {
    borderBottom: "none",
  },
  "& .data-table-row:last-of-type .workout-table-row": {
    borderBottom: "none",
  },
}));

export const MultiSelectCheckbox = styled(Mui5.Checkbox)((props) => ({
  color: props.theme.palette.common.white,
  "&.Mui-checked": { color: props.theme.palette.common.white },
  "&.MuiCheckbox-indeterminate": { color: props.theme.palette.common.white },
  opacity: 0.85,
}));

export const TableRow = styled("div")<{ selected?: boolean }>((props) => ({
  minHeight: 56,
  borderBottom: `1px solid ${props.theme.palette.grey[400]}`,
  boxSizing: "border-box",
  backgroundColor: props.selected ? alpha(props.theme.palette.primary.main, 0.1) : undefined,
}));

const HeaderCellContainer = styled("div")((props) => ({
  display: "flex",
  alignItems: "center",
  gap: props.theme.spacing(0.5),
  overflow: "hidden",
}));

interface HeaderCellProps {
  startIcon?: React.ReactNode;
  children: React.ReactNode;
  slotProps?: {
    root?: DivProps;
    typography?: TypographyProps;
  };
}

export function HeaderCell(props: HeaderCellProps) {
  const { startIcon, children, slotProps } = props;

  return (
    <HeaderCellContainer {...slotProps?.root}>
      {startIcon ? startIcon : null}
      <Typography
        variant="TextS"
        noWrap
        sx={{ fontWeight: "fontWeightMedium", cursor: "default" }}
        {...slotProps?.typography}
      >
        {children}
      </Typography>
    </HeaderCellContainer>
  );
}
